import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  ENVIRONMENT,
  EnvironmentModel,
} from '@lyceo/homi/shared/util-environment';
import { CourseDto } from './+state/course/course.dto';

@Injectable({
  providedIn: 'root',
})
export class CourseService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly environment: EnvironmentModel =
    inject<EnvironmentModel>(ENVIRONMENT);

  public getCoursesByWebsite(websiteId: string): Observable<CourseDto[]> {
    const url: string = `${this.environment.homiApiUrl}/api/courses/website/${websiteId}`;
    const headersToSend: HttpHeaders = new HttpHeaders().set(
      'Accept',
      'application/json',
    );
    return this.http.get<CourseDto[]>(url, {
      headers: headersToSend,
    });
  }
}
